// -- copyright
// OpenProject is a project management system.
// Copyright (C) 2012-2015 the OpenProject Foundation (OPF)
//
// This program is free software; you can redistribute it and/or
// modify it under the terms of the GNU General Public License version 3.
//
// OpenProject is a fork of ChiliProject, which is a fork of Redmine. The copyright follows:
// Copyright (C) 2006-2013 Jean-Philippe Lang
// Copyright (C) 2010-2013 the ChiliProject Team
//
// This program is free software; you can redistribute it and/or
// modify it under the terms of the GNU General Public License
// as published by the Free Software Foundation; either version 2
// of the License, or (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program; if not, write to the Free Software
// Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
//
// See doc/COPYRIGHT.rdoc for more details.
// ++

import {Component, Injector, Input, ChangeDetectorRef, DoCheck, KeyValueDiffers, KeyValueDiffer} from '@angular/core';
import {I18nService} from 'core-app/modules/common/i18n/i18n.service';
import {FieldDescriptor, GroupDescriptor} from 'core-components/work-packages/wp-single-view/wp-single-view.component';
import {WorkPackageResource} from 'core-app/modules/hal/resources/work-package-resource';
import {EditFormComponent} from "core-app/modules/fields/edit/edit-form/edit-form.component";
import { HttpClient } from '@angular/common/http';
import {HandlerCheckObserveService} from '../../components/HandlerCheckObserve.service'

//判断3有没有被选中，选中就启用4 没有禁用4
@Component({
  selector: 'wp-attribute-group',
  styleUrls: ['./wp-attribute-group.sass'],
  templateUrl: './wp-attribute-group.template.html'
})
export class WorkPackageFormAttributeGroupComponent implements DoCheck {
  @Input() public workPackage:WorkPackageResource;
  //group 渲染规则
  @Input() public group:GroupDescriptor;
  @Input() public groupimgdata:any;
  @Input() public signusername:any;
  @Input() public signuserzhu:any;
  @Input() public groupedFields: any
  @Input() public is_project_admin: any
  //服务
  //Inspection detail选项卡中渲染的文本数组
  public textArr:any[] = [];
  public groupitem=0
  public dipslesignature = false
  public signatureImage:any
  public signloding:any
  public memberssignitem:any = []
  public customFieldGroupPrincipal:any = []
  public selectCustomFieldGroup:any = null
  public okselect:boolean = true
  public numer:any =[]
  public check = false
  public isDefoultSign =  false
  public currentUser:any = document.querySelector('meta[name=current_user]')
  public defaultSign:any
  public hasEmptyRequiredFields:boolean = false
  private workPackageDiffer:KeyValueDiffer<string, any> | null = null
  public checlist:any = {
    'There is no objection to you proceeding with the work.': false,
    'Survey record has been taken': false,
    'The following deficiencies have been noted:': false,
    'Work reinspected, no objection to you proceeding.': false ,
    // 'Detail of deficiencies': false,
    'Not Ready':false

  }
  public checkdiabale:any = {
    'There is no objection to you proceeding with the work.': false,
    'Survey record has been taken': false,
    'The following deficiencies have been noted:': false,
    'Work reinspected, no objection to you proceeding.': false ,
    // 'Detail of deficiencies': false,
    'Not Ready':false
  }
  requestHeader: any = {
    'X-Authentication-Scheme': 'Session',
    'X-Requested-With': 'XMLHttpRequest'
  };
  //API前缀
  apiPrefix: any = '/api/v3';
  public itemlabel = [
    'There is no objection to you proceeding with the work.',
    'Survey record has been taken',
    'The following deficiencies have been noted:',
    'Work reinspected, no objection to you proceeding.' ,
    // 'Detail of deficiencies',
    'Not Ready'
  ]
  public text = {
    date: {
      startDate: this.I18n.t('js.label_no_start_date'),
      dueDate: this.I18n.t('js.label_no_due_date')
    },
  };
  public mustNotBeBlank = [
    'Document Reference',
    '(1) Location of Work',
    '(2) Work to be inspected/surveyed',
    '(2) Date & Time',
    '(3) Work Proposed after Approval of (2)',
    '(3) Date & Time'
   ]
   public checkFun:any
  public ngOnInit() {

    // console.log(this.groupimgdata,'asdasdasdasdasdadasd')
    if(this.workPackage.id != 'new')this.get_custom_field_group_available_principal(this.group.name)
    if(this.workPackage.type.name != 'RISC' && this.workPackage.type.name != 'RISC(inspection)') return
    this.loadDefault()
    this.group.members.forEach( (descriptor:any) => {
      this.checlist[descriptor.label.trim()] = this.workPackage[descriptor.name]
    }) 
    this.checkRELOWLS()
    this.checkFun = this.detailSet()
    this.checkFun.pushList([0,1], [2,3,4])
    this.checkFun.pushList([0], [2,3,4])
    this.checkFun.pushList([2], [0,3,4])
    this.checkFun.pushList([1], [3,4])
    this.checkFun.pushList([3], [0,1,2,4])
    this.checkFun.pushList([4], [0,1,2,3])
    this.checkFun.setCheckList()
    this.checkFun.run()
    this.group.members.forEach((res:any)=>{
       if(!res.field.writable) this.okselect = false
       if(res.label.indexOf('Signature')>=0 ){
         this.memberssignitem.push(res)
       }
      })
      if(!this.group.status.find( (item:any) => {
        return item.id == this.workPackage.status.id
      }) && !this.is_project_admin) {
        this.okselect = false
      }
      if(this.workPackage.status.name == 'New'){
      this.okselect = true
      }
      //判断Inspection 选项卡进行操作
      if(this.group.name == 'Inspection detail'){
        //创建新数组testArr
        this.group.members.forEach((item) =>{
          if(this.itemlabel.indexOf(item.label.trim()) != -1){
            this.textArr.push(item.label) //修改的四个选项卡的文字字段


          }
        })
      }
      // 初始化 workPackage 变化检测器
      this.workPackageDiffer = this.differs.find(this.workPackage).create()
      // 初始检查必填字段状态
      this.updateRequiredFieldsStatus()
  }
   public ngAfterViewInit(){

   }

  /**
   * Angular DoCheck 生命周期钩子
   * 在每次变化检测周期中调用，用于检测 workPackage 的变化
   */
  public ngDoCheck() {
    if (this.workPackageDiffer) {
      const changes = this.workPackageDiffer.diff(this.workPackage)
      if (changes) {
        // workPackage 发生了变化，更新必填字段状态
        this.updateRequiredFieldsStatus()
      }
    }
  }

  /**
   * 更新必填字段验证状态
   * 将结果存储在 hasEmptyRequiredFields 属性中，避免在模板中重复计算
   */
  private updateRequiredFieldsStatus() {
    this.hasEmptyRequiredFields = this.checkMustNotBlankFields()
  }
  //渲染CheckBox选框判断
  ArrFn(descriptor:any){
    if(this.textArr.indexOf(descriptor.label)>-1){
      return true
    }else{
      return false
    }
    
  }
  loadDefault() {
    let sign = this.group.members.find( (item:any) => {
      return item.label.indexOf('Signature') !== -1
    })

    if(sign) {

      if(this.workPackage.customDefaultSignValues[sign!.name]){
     
        this.defaultSign =  `${window.location.origin}/api/v3/logical_docs/doc/${
          this.workPackage.customDefaultSignValues[sign!.name]
        }/stream`
         this.isDefoultSign = true
        
    
     
      } else {
        this.defaultSign = this.currentUser.dataset.sign_doc_id.length > 0 ? `${window.location.origin}/api/v3/logical_docs/doc/${
          this.currentUser.dataset.sign_doc_id
        }/stream`: false
        this.isDefoultSign = false
 
     
      }
    }
  }
  ValueContainerContentStyle(descriptor:any) {


      return {'border-color':(this.workPackage.id == 'new' || this.userquanx(descriptor.name)) || this.Tip() || this.hasEmptyRequiredFields ? '#e3e3e3':'rgba(6, 150, 215, 1)', 'cursor': this.workPackage.id == 'new'?'auto':'pointer'}


  }
  checkRELOWLS() {
    let checkGround = this.groupedFields.find( (item:any) => {
      return item.name == 'Inspection detail'
    }).members
    this.check = checkGround.some( (res:any) => {
       return res.field.value === true
    })
  }
  ValueContainerContentIconStyle(descriptor:any,check?:any) {
      return {'background-color':(this.workPackage.id == 'new' || this.userquanx(descriptor.name)) || this.Tip() || this.hasEmptyRequiredFields ? '#e3e3e3':'rgba(6, 150, 215, 1)', 'cursor': this.workPackage.id == 'new'?'auto':'pointer'}
  }

//INSPECTION DETAIL 选项卡中checkBox点击事件
  checkTrue($event:any){
    let that = this;

    let name =  this.numer.find( (item:any) => {
      return $event.target.id == item.id
    }).name //每次点击的文本
    this.checlist[name] = $event.target.checked
    this.checkFun.run()
    //绑定服务
    let redata:any = {lockVersion: this.workPackage.lockVersion, _links: {},}
    //当前选中选项卡
    let reid:any = $event.target.id
    //是否被选中
    redata[reid] = $event.target.checked
    this.requefunckpost(redata,`${window.location.origin}/api/v3/work_packages/${this.workPackage.id}/form`).subscribe((data:any)=>{
      // redata['lockVersion'];//当前最新版本号
      redata['lockVersion'] = data._embedded.payload.lockVersion
        this.requefunckpatch(redata,`${window.location.origin}/api/v3/work_packages/${this.workPackage.id}`).subscribe((res:any)=>{
          this.workPackage.lockVersion = res.lockVersion
          this.workPackage.customDefaultSignValues = res.customDefaultSignValues
          this.handlerCheck.eventBus.emit('workpackgeChange')
        })
    })
  }
  
  detailSet() {
    let list: (() => void)[] = []
    return {
      pushList: (trueList:Array<number>, disableList:Array<number>)=> {
        list.push( () => {
          let isCheck = true
          trueList.forEach( (index) => {
    
            isCheck = isCheck && this.checlist[this.itemlabel[index]]
          })
          if(isCheck) {
            disableList.forEach( (index) => {
              this.checkdiabale[this.itemlabel[index]] = true
            })
          }
        })
      },
      run:() =>{
        this.itemlabel.forEach( (label) => {
          this.checkdiabale[label] = false
        })
        list.forEach( (item:any) => {

          item()
        })
      },
      setCheckList: () => {
        let checkGround = this.groupedFields.find( (item:any) => {
          return item.name == 'Inspection detail'
        }).members
        checkGround.forEach( (res:any) => {
            this.checlist[res.field.label] = res.field.value
        })
      }
    }
  }
  //动态添加id标识
  numerdata(descriptor:any){
    let index = this.numer.find((data:any) => {
      return data.id == descriptor.name
    });
    if(!index)this.numer.push({id:descriptor.name,name:descriptor.label})
    return descriptor.name
  }

  constructor(readonly I18n:I18nService,
              public wpeditForm:EditFormComponent,
              protected injector:Injector,
              private http: HttpClient,
              private changeDetectorRef:ChangeDetectorRef,
              public handlerCheck: HandlerCheckObserveService,
              private differs:KeyValueDiffers) {
  }

  public trackByName(_index:number, elem:{ name:string }) {
    return elem.name;
  }

  /**
   * Hide read-only fields, but only when in the create mode
   * @param {FieldDescriptor} field
   */
  public shouldHideField(descriptor:FieldDescriptor) {
    const field = descriptor.field || descriptor.fields![0];
    return this.wpeditForm.editMode && !field.writable;
  }


  displaysign(index:any){
    this.groupitem = index

    if(this.workPackage.id == 'new'||this.workPackage[this.group.members[index].name] || this.userquanx(this.group.members[index].name) || this.Tip() || this.hasEmptyRequiredFields)return
    this.dipslesignature = true

  }

  displaymodel(name:string){
    if(this.workPackage.type.name == "RISC" ||this.workPackage.type.name ==  "RISC(inspection)"){
      return name.indexOf('Signature')<0 ? true : false
    }else{
      return true
    }    
  }

  isSign (index:any) {
    return !(this.workPackage.id == 'new'||this.workPackage[this.group.members[index].name] || this.userquanx(this.group.members[index].name) || this.Tip())
  }
  closeView(img:any){
    
    this.signatureImage = img
    
    if(!img) {
      this.dipslesignature = false 
      return
    }
  
    this.groupimgdata[this.group.members[this.groupitem].name] = img
    
    let blob = this.dataURLtoBlob(img)
    this.signloding = img ? this.groupitem : ''
    var files = new File([blob], 'drawComplete.png', { type: blob.type })
    let file = new FormData();
    file.append('file', files);
    file.append('prefix', 'risc');
    this.dipslesignature = false
    let projectId:any = document.querySelector('meta[name=current_project]')

    this.http.get(`/api/v3/work_packages/${this.workPackage.id}`).subscribe((worlpageres:any)=>{
      this.requefunckpost(file,`${this.apiPrefix}/projects/${projectId.dataset.projectId}/sign`).subscribe((imgdata:any)=>{
        let requedata:any = {lockVersion: worlpageres.lockVersion,_links: {}}
        
        // this.requefunckpost(requedata,`${this.apiPrefix}/work_packages/${this.workPackage.id}/form`).subscribe((data:any)=>{
          requedata[this.group.members[this.groupitem].name] = imgdata.doc_id

          this.requefunckpatch(requedata,`${this.apiPrefix}/work_packages/${this.workPackage.id}`).subscribe((res:any)=>{
              this.workPackage[this.group.members[this.groupitem].name] = res[this.group.members[this.groupitem].name]
              this.workPackage.lockVersion = res.lockVersion
              this.signloding = null
              this.changeDetectorRef.markForCheck();
              this.changeDetectorRef.detectChanges();
              this.handlerCheck.eventBus.emit('showDialog')
          })
        })
      // })
    })
    this.groupimgdata[this.group.members[this.groupitem].name] = img     
  }

  dataURLtoBlob(dataurl:any) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }

  urlsubscribe(){
    
  }

  checkDefaultSignChange(name:any) {
    if(this.isDefoultSign) {
      this.http.post(
        `/api/v3/work_packages/${this.workPackage.id}/custom_fields/set_defauls_sign`,
        {
          custom_sign_field_name: name,
          custom_sign_field_default_value: this.currentUser.dataset.sign_doc_id
        },
        {
          withCredentials: true,
          headers: this.requestHeader
        }
      ).subscribe( (res) => {
   
      })
    } else {
      this.http.post(
        `/api/v3/work_packages/${this.workPackage.id}/custom_fields/set_defauls_sign`,
        {
          custom_sign_field_name: name,
          custom_sign_field_default_value: ''
        },
        {
          withCredentials: true,
          headers: this.requestHeader
        }
      ).subscribe( (res) => {
    
      })
    }
  }

  userquanx(name:any, type?:any){
    // if(this.okselect) return false
    let signdata:any = this.group
    // console.log(signdata)
    if(this.is_project_admin && type == 'Inspection') {
      return false
    }
    if(!this.group.status.find( (item:any) => {
      return item.id == this.workPackage.status.id
    }) ) {
      if(this.is_project_admin && type == 'Inspection') {
     
      } else {

        return true
      }
    }
    if(this.customFieldGroupPrincipal.length == 0) return true
    if(!signdata.sign.real_principal_name){
      let index = this.customFieldGroupPrincipal.find((res:any)=>{
        return `${res.lastname} ${res.firstname}` == signdata.sign.principal_name
      })
      if(!index) return true
      return index.mail != this.currentUser.dataset.mail
    }else{
      let index = this.customFieldGroupPrincipal.find((res:any)=>{
        return `${res.lastname} ${res.firstname}` == signdata.sign.real_principal_name
      })
      if(!index) return true
      return index.mail != this.currentUser.dataset.mail 
    }

  }

  //下拉框下面的文字
  dipssignuser(name:any){
    let signdata:any = this.group
    if(signdata.sign.real_principal_name && signdata.sign.principal_name) return ''
    let index = this.customFieldGroupPrincipal.find((res:any)=>{
      return `${res.lastname} ${res.firstname}` == signdata.sign.principal_name || `${res.lastname} ${res.firstname}` == signdata.sign.real_principal_name
    })
    if(!index)return `${signdata.sign.principal_name}`
    let position = index.position?`[${index.position}]` : ''
    return signdata.sign.real_principal_name? `${position}${signdata.sign.real_principal_name}` : `${position}${signdata.sign.principal_name}`
    // if(signdata.sign.type == 'User'){

    // }else{
    //   return signdata.sign.real_principal_name? signdata.sign.real_principal_name :`Please assign to a specific User instead of a User Group for signature purpose.`
    // }
    // if(this.signusername) {
    //   let username = this.signusername.sign_custom_fields.find((res:any)=>{
    //     return 'customField'+res.id == name
    //   })
    //   return username.responsible.name
    // }

  }


  get_custom_field_group_available_principal(element:any){
      this.http.get(`/api/v3/work_packages/${this.workPackage.id}/custom_field_group_available_principal?custom_field_group_name=${element}`).subscribe((res:any)=>{
        this.customFieldGroupPrincipal= res.principals
        let panduan = true
        let elementpadnuan = true
        let name = ''

         
          res.principals.forEach((element:any, i:any) => {
            if(i == 0){
              if(element.lastname || element.firstname) {

                name = element.lastname + element.firstname
              } else {
                name += element.name 
              }
            } else {
              if(element.lastname || element.firstname) {

                name = name + ','+ element.lastname + element.firstname
              } else {
                name += ',' + element.name 
              }
            }
          });
        
        for(let i = res.principals.length -1 ; i>=0 ; i--) {
          if(res.principals[i].hasOwnProperty('users')) {
            let users: Array<any> =  res.principals[i].users
       
            res.principals.splice(i + 1,0, ...users)
          }
        }
        res.principals.forEach((prinres:any, i: any) => {
          
          if(panduan){
            if(this.group.real_principal_name == `${prinres.lastname} ${prinres.firstname}` ||  (this.group.real_principal_name == `${prinres.lastname} ${prinres.firstname}`.trim() || this.group.real_principal_name == prinres.name) ){
              this.selectCustomFieldGroup = prinres.id
              panduan = false
            } 
            if(!this.group.real_principal_name && (this.group.principal_name == `${prinres.lastname} ${prinres.firstname}` ||  (this.group.principal_name == `${prinres.lastname} ${prinres.firstname}`.trim() || this.group.principal_name == prinres.name)) ) {
              this.selectCustomFieldGroup = prinres.id
              panduan = false
            }
            // else if(element !== 'FOR Contractor: Submission detail'){
            //   if(elementpadnuan){
            //     this.selectCustomFieldGroup = null
            //     //每一个子分类的选项
            //     this.customFieldGroupPrincipal.unshift({id:null,login:this.group.principal_name})
            //     elementpadnuan = false
            //   }
              
            // }
          }
        });
        if(panduan){
          
   
          res.principals.unshift({
            id:null,
            login: name
          })
        }
      })
  }
  selectName(item:any){
    if(item.id){
      //item 中有id的是人，需要添加职位
      let position = item.position? '['+item.position+']' : ''
      if(item.firstname || item.lastname) {

        return `${position} ${item.firstname} ${item.lastname}`
      } else{
        return `${position} ${item.name} `
      }
    }else{
      //没有id的是组
      return item.login
    }
    
  }

  //签名错误
  userzhuPlease(){
    let signdata:any = this.group
    const currentUser: any = document.querySelector('meta[name=current_user]');
    if(signdata.sign.real_principal_name){
      let index = this.customFieldGroupPrincipal.find((res:any)=>{
        return `${res.lastname} ${res.firstname}` == signdata.sign.real_principal_name
      })
      if(!index) return true
      return false
    }else{
      return false
    }
    
  }
  Tip() {
    let check = false
    let checkGround = this.groupedFields.find( (item:any) => {
      return item.name == 'Inspection detail'
    }).members
    checkGround.forEach( (res:any) => {
      if(res.field.value == true){
        check = true
      }
    })
      return (this.group.name ==='Form returned and signed by RE/IOW/LS') &&  !check
  }

  /**
   * 检查必填字段是否已填写
   * 返回 true 表示有必填字段未填写（应该阻止签名）
   * 返回 false 表示所有必填字段都已填写（允许签名）
   */
  checkMustNotBlankFields() {
    // 如果是新建模式，不检查必填字段
    if (this.workPackage.id == 'new') {
      return false
    }

    // 检查所有必填字段
    for (const label of this.mustNotBeBlank) {
      let fieldFound = false
      // 在所有分组中查找该字段
      for (const group of this.groupedFields) {
        const field = group.members.find((m: any) => m.label && m.label.trim() === label.trim())
        if (field) {
          fieldFound = true
          // 尝试多种方式获取字段值
          let value = this.workPackage[field.name]

          // 如果直接访问没有值，尝试从 customFields 中获取
          if (!value && this.workPackage.customFields) {
            // 检查是否是自定义字段（格式可能是 customFieldNN）
            const customFieldKey = Object.keys(this.workPackage.customFields).find(key => {
              const customField = this.workPackage.customFields[key]
              return customField && customField.name === field.name
            })
            if (customFieldKey) {
              const customField = this.workPackage.customFields[customFieldKey]
              value = customField && customField.value
            }
          }

          // 提取实际的内容值（处理格式化字段）
          let actualValue = value
          if (value && typeof value === 'object') {
            // 对于格式化字段（markdown等），检查 raw 或 html 内容
            actualValue = value.raw || value.html || value.value
          }

          // 检查字段值是否为空
          const isEmpty = actualValue === null || actualValue === undefined || actualValue === '' ||
                         (typeof actualValue === 'string' && actualValue.trim() === '')

          if (isEmpty) {
            return true
          }
          break // 找到字段后就跳出内层循环
        }
      }
    }
    return false
  }

  //handler下拉框选项改变，重新刷新一次页面
  changesCustomFieldGroup(){
    let customField = this.customFieldGroupPrincipal.find( (item:any) => {
   
      return item.id == Number(this.selectCustomFieldGroup)
    })
    let file = {custom_field_group_name:this.group.name,principal_id:this.selectCustomFieldGroup} as any
    if(customField.type) {
      file.principal_type =  customField.type
    }
    this.requefunckpatch(file,`${this.apiPrefix}/work_packages/${this.workPackage.id}/change_custom_field_group_principal`).subscribe((res:any)=>{
      if(res == 200){
        this.http.post(
          `/api/v3/work_packages/${this.workPackage.id}/custom_fields/set_defauls_sign`,
          {
            custom_sign_field_name: name,
            custom_sign_field_default_value: ''
          },
          {
            withCredentials: true,
            headers: this.requestHeader
          }
        ).subscribe( (res) => {
      
          this.handlerCheck.eventBus.emit('handleChange')
        })
      }
    })
  }

  requefunckpatch(data: any,url:any){
    return this.http.patch(
      url,
      data,
      {
        withCredentials: true,
        headers: this.requestHeader
      }
    );
  }

  requefunckpost(data: any,url:any){
    return this.http.post(
      url,
      data,
      {
        withCredentials: true,
        headers: this.requestHeader
      }
    );
  }

  requefunckget(url:any){
    return this.http.get(
      url,
      {}
    );
  }


}
